import { createSearchUI, SearchUI } from './searchUI';
import { ISearchResult } from './interface';
import Axios from 'axios';

/**
 * Navigation Component
 * Handle all interactions for the navigation
 */

class Search {
  /**
     * Constructor
     * Set events, etc.
     * @param ui - UI for the navigation
     */
  constructor(private ui: SearchUI) {
    this.registerEvents();

    // Fetch Navigation Data
    // My Server menu…

    // Hardcoded Server.ServerEventType.GAMESERVERQUERY_EVENT for optimization reasons.
    // Please don't import Server to keep the build of app_small.js small (as its name suggests ;)).
    window.addEventListener('gameserverquery', (event: CustomEvent<any>) => {
      // console.log(event.detail.server);
      this.ui.GamecloudData = event.detail.server;
      this.ui.render();
      this.registerEvents();
    });

    /**
         * Register a handler as soon as the user enter a text in the searchfield
         * Update the UI to show the searchresults
         */
    this.ui.onSearchInput((value) => this.getSearchResults(value).then((response) => {
      this.ui.render(response);
      this.registerEvents();
    }));
  }

  private registerEvents() {
    this.ui.onWindowSearchOpen();
    this.ui.onSearchHideClick();
  }

  /**
     * Fetch search results from API
     * @param value the search value
     */
  private getSearchResults(value: string): Promise<ISearchResult> {
    const url: string = window.location.hostname.includes('g-portal.us') ? `https://search.g-portal.us/all/${window.customerLanguageCode}/${encodeURI(value)}` : `https://search.g-portal.com/all/${window.customerLanguageCode}/${encodeURI(value)}`;
    this.ui.loading(true);
    return new Promise((resolve, reject) => {
      Axios.get(url).then((response) => {
        resolve(response.data);
        this.ui.loading(false);
      }).catch((error) => {
        reject(error);
        this.ui.loading(false);
      });
    });
  }
}

export function initSearch() {
  return createSearchUI().map((ui: SearchUI) => new Search(ui));
}
